import {
  getNativeDeviceToken
} from './nativeDeviceAuth';


const SUPABASE_URL =
  process.env
    .REACT_APP_SUPABASE_URL;

const SUPABASE_KEY =
  process.env
    .REACT_APP_SUPABASE_PUBLISHABLE_KEY;


async function callEvents(
  session,
  action,
  payload = {}
) {
  if (!session) {
    throw new Error(
      'A student session is required.'
    );
  }

  const body = {
    actorType:
      'student',

    action,
    ...payload
  };

  if (
    session.nativeDeviceSession ===
      true
  ) {
    const deviceToken =
      await getNativeDeviceToken();

    if (!deviceToken) {
      throw new Error(
        'A saved mobile login is required.'
      );
    }

    body.deviceToken =
      deviceToken;

  } else {
    const webSessionToken =
      String(
        session.webSessionToken ||
        ''
      ).trim();

    if (!webSessionToken) {
      throw new Error(
        'Your student web session is no longer available. Please sign in again.'
      );
    }

    body.webSessionToken =
      webSessionToken;
  }

  const response =
    await fetch(
      SUPABASE_URL +
        '/functions/v1/honors-events',
      {
        method: 'POST',

        headers: {
          apikey:
            SUPABASE_KEY,

          Authorization:
            'Bearer ' +
            SUPABASE_KEY,

          'Content-Type':
            'application/json'
        },

        body:
          JSON.stringify(
            body
          )
      }
    );

  const text =
    await response.text();

  const result =
    text
      ? JSON.parse(text)
      : null;

  if (
    !response.ok ||
    result?.ok === false
  ) {
    throw new Error(
      result?.error ||
      'Events request failed.'
    );
  }

  return result;
}



export function honorsEventCategory(event) {
  const category = event?.eventCategory === 'information_session'
    ? 'information_session'
    : event?.eventCategory === 'other' ? 'other' : 'forum';

  const themes = {
    forum: {
      accent: '#8062a4',
      background: '#f5f0fa',
      text: '#624487'
    },
    information_session: {
      accent: '#ce8749',
      background: '#fff4e9',
      text: '#96521c'
    },
    other: {
      accent: '#78afcc',
      background: '#eef7fc',
      text: '#326d91'
    }
  };

  const label = category === 'forum'
    ? 'Honors Forum'
    : category === 'information_session'
      ? 'Honors Information Session'
      : String(event?.eventOtherLabel || '').trim();

  return { category, label, ...themes[category] };
}

export function honorsEventRegistrationLabel(event) {
  return [
    honorsEventCategory(event).label,
    'Register Now'
  ].filter(Boolean).join(' · ');
}

export function
listStudentHonorsEvents(
  session
) {
  return callEvents(
    session,
    'list'
  );
}


export function
saveStudentEventRegistration(
  session,
  eventId,
  values
) {
  return callEvents(
    session,
    'register',
    {
      eventId,
      ...values
    }
  );
}


export function
cancelStudentEventRegistration(
  session,
  eventId
) {
  return callEvents(
    session,
    'cancel',
    {
      eventId
    }
  );
}
